export default class NextButtonPanel {
  static html(title, filmTitle, thumbnailUrl){
    return `
      <h4 class='vjs-next-button__panel-title'>Next Video</h4>
      <div class='vjs-next-button__panel-bottom'>
        <div class='vjs-next-button__panel-thumbnail' style='background: url("${thumbnailUrl}"); background-size:cover;'>
        </div>
        <div class='vjs-next-button__panel-detail'>
          <h5 class='vjs-next-button__panel-video-title'>${title}</h5>
          <p class='vjs-next-button__panel-film-title'>${filmTitle}</p>
        </div>
      </div>
    `;
  }
}
